import { render, staticRenderFns } from "./Inspectie_finala_pdf.vue?vue&type=template&id=2bf55a00&"
import script from "./Inspectie_finala_pdf.vue?vue&type=script&lang=js&"
export * from "./Inspectie_finala_pdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports